import React, { useCallback } from "react";
import { Button } from "theme-ui";
import PropTypes from "prop-types";
import { useAlert } from "../../../alert";

ConfirmButton.propTypes = {
  title: PropTypes.any,
  onClick: PropTypes.func,
  children: PropTypes.any,
  text: PropTypes.string,
};

export function ConfirmButton(props) {
  const { showAlert } = useAlert();

  const setD = useCallback(() => {
    const alert = {
      title: props.title,
      message: "Are you Sure?",
      confirm_text: "Yes",
      cancel_text: "No",
      confirm_callback: props.onClick,
      is_blocking: true,
    };
    showAlert(alert);
  }, []);

  return props.children ? (
    <span style={{ cursor: "pointer" }} onClick={setD}>
      {props.children}
    </span>
  ) : (
    <Button style={{ cursor: "pointer" }} onClick={setD}>
      {props.text}
    </Button>
  );
}
